import { render } from "./android4DownloadInstructions.vue?vue&type=template&id=2c03c8b5&scoped=true&ts=true"
import script from "./android4DownloadInstructions.vue?vue&type=script&lang=ts"
export * from "./android4DownloadInstructions.vue?vue&type=script&lang=ts"

import "./android4DownloadInstructions.vue?vue&type=style&index=0&id=2c03c8b5&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c03c8b5"]])

export default __exports__